import { i18n } from '@/plugins/i18n'

export default [
    {
        url: '/',
        icon: 'fa fa-home',
        name: i18n.t('aside.home'),
        submenu: [],
        is_navigation: false,
        exact:true
    },
    {
        url: '/users',
        icon: 'fa fa-user',
        name: i18n.t('aside.users'),
        submenu: [],
        is_navigation: false,
        rules: {
            "user": ['read-general-info']
        },
    },
    {
        url: '/stakeholders/pf',
        icon: 'fa fa-users',
        name: i18n.t('aside.stakeholders'),
        submenu: [],
        is_navigation: false,
    },
    {
        url: '/pf-gateways',
        icon: 'fa fa-torii-gate',
        name: i18n.t('aside.pf_gateways'),
        submenu: [ ],
        is_navigation: false,
    },
    // {
    //     url: '/wallets',
    //     icon: 'fas fa-wallet',
    //     name: i18n.t('aside.manage_wallets'),
    //     submenu: [],
    //     is_navigation: false,
    // },
    {
        url: '/wallets/admin/pf',
        icon: 'fas fa-wallet',
        name: i18n.t('aside.manage_wallets_admin'),
        submenu: [
        ],
        is_navigation: false,
        rules: {
            "wallet": ['read'],
            "wallet-operator": ['read'],
        },
    },
    {
        url: '/pf/accounting',
        icon: 'fa fa-address-card',
        name: i18n.t('aside.accounting'),
        submenu: [
        ],
        is_navigation: false,
        rules: {
            "accounting": ["read"]
        }
    },
    {
        url: '/reports',
        icon: 'fas fa-chart-bar',
        name: i18n.t('aside.reports'),
        submenu: [
            {
                url: '/reports/users',
                name: i18n.t('aside.users_reports'),
                is_navigation: false,
            },
            {
                url: '/reports/gateways',
                name: i18n.t('aside.gateways_reports'),
                is_navigation: false,
            },
            {
                url: '/reports/top-users-chart',
                name: i18n.t('reports.users.top_users_chart'),
                is_navigation: false,
            },
            {
                url: '/reports/pf-terminal-statistics',
                name: i18n.t('aside.pf_terminal_statistics'),
                is_navigation: false,
            },
            {
                url: '/reports/shaparak-excel',
                name: i18n.t('aside.shaparak_excel'),
                is_navigation: false,
            },
        ],
        is_navigation: false,
        rules: {
            "ipg-gateway": ["read"]
        }
    },
    {
        url: '/psp-request',
        icon: 'fa fa-cubes',
        name: i18n.t('aside.manage_psp_requests'),
        submenu: [],
        is_navigation: false,
        rules: {
            "ipg-gateway": ["read"]
        }
    },
    {
        url: '/shaparak-requests',
        icon: 'fa fa-th-list',
        name: i18n.t('aside.shaparak_requests'),
        is_navigation: false,
        submenu: [],
        rules: {
            "ipg-gateway": ["read"]
        }
    },
    {
        url: '/transactions',
        icon: 'fa fa-dollar-sign',
        name: i18n.t('aside.transactions'),
        submenu: [
            {
                url: '/transactions/monitoring',
                name: i18n.t('aside.pardakhtyari_transactions_monitoring'),
                is_navigation: false,
            },
            {
                url: '/transactions/pardakhtyari',
                name: i18n.t('aside.pardakhtyari_transactions'),
                is_navigation: false,
            },
            {
                url: '/transactions/notifications-setting',
                name: i18n.t('aside.notificationـsetting'),
                is_navigation: false,
                rules: {
                    "transaction": "manage-transaction-setting"
                }
            },
            {
                url: '/transactions/inquiry',
                name: i18n.t('aside.transaction_inquiry'),
                is_navigation: false,
                rules: {
                    "transaction": "inquiry-transaction"
                },
            },
        ],
        is_navigation: false,
    },
    {
        url: '/transaction-routing/pardakhtyari',
        icon: 'fa fa-random',
        name: i18n.t('aside.transaction_routing'),
        submenu: [],
        is_navigation: false,
        rules: {
            "transaction": ["manage-transaction-setting"]
        }
    },
    {
        url: '/settlements',
        icon: 'fa fa-calculator',
        name: i18n.t('aside.settlement'),
        submenu: [],
        is_navigation: false,
    },
    {
        url: '/tickets',
        icon: 'fa fa-ticket-alt',
        name: i18n.t('aside.tickets'),
        submenu: [],
        is_navigation: false,
    },
    {
        url:'/knowledge-management',
        icon: 'fa fa-info-circle',
        name: i18n.t('aside.knowledge_management'),
        submenu: [
            {
                url: '/knowledge-management',
                name: i18n.t('aside.admins'),
                is_navigation: false,
            },
            {
                url: '/faq',
                name: i18n.t('aside.user-FAQ'),
                is_navigation: false,
            }
        ],
        is_navigation: false,
        rules: {}
    },
    {
        url: '/notifications',
        icon: 'fas fa-bullhorn',
        name: i18n.t('aside.notifications'),
        submenu: [],
        is_navigation: false,
        rules: {
            "notification": ["read"],
        },
    },
    {
        url: '/online-factor',
        icon: 'fas fa-qrcode',
        name: i18n.t('aside.factor_online'),
        submenu: [],
        is_navigation: false,
        rules: {},
    },
    {
        url: "/news",
        icon: "fa fa-bell",
        name: i18n.t("aside.news"),
        submenu: [],
        is_navigation: false,
        rules: {
            "notification": ["read"],
        }
    },
    {
        url: '/settings',
        icon: 'fa fa-cogs',
        name: i18n.t('aside.settings'),
        submenu: [
            {
                url: '/profile',
                name: i18n.t('aside.profile'),
                is_navigation: false,
            },{
                url: '/online-contract/contracts',
                name: i18n.t('aside.online_contracts'),
                is_navigation: false,
            },

            {
                url: '/notification-email',
                name: i18n.t('aside.notification_email'),
                submenu: [],
                is_navigation: false,
            },
            {
                url: '/notification-sms',
                name: i18n.t('aside.notification_sms'),
                submenu: [],
                is_navigation: false,
            },
            {
                url: '/notification-telegram',
                name: i18n.t('aside.notification_telegram'),
                submenu: [],
                is_navigation: false,
            },
            {
                url: '/profile/change-password',
                name: i18n.t('aside.change_password'),
                submenu: [],
                is_navigation: false,
            },
            {
                url: '/access-token',
                name: i18n.t('label.access_token'),
                submenu: [],
                is_navigation: false,
            },
            {
                url: '/authentication-settings',
                name: i18n.t('label.authentication_settings'),
                submenu: [],
                is_navigation: false,
                rules: {
                    "user": 'read-sensitive-info'
                },
            },
            {
                url: '/settlements/settings',
                name: i18n.t('aside.settlement_settings'),
                submenu: [],
                is_navigation: false,
                rules: {
                    "settlement": ['read']
                },
            },
        ],
        is_navigation: false,
    },
    {
        url: '/security',
        icon: 'fa fa-user-secret',
        name: i18n.t('aside.security'),
        submenu: [
            {
                url: '/security/black-list',
                name: i18n.t('aside.black-list'),
                is_navigation: false,
                rules: {
                    "security": "manage-black-list"
                },
            },
            {
                url: '/fraud-events',
                name: i18n.t('aside.transaction_fraud_event_list'),
                is_navigation: false,
                rules: {
                    "security": "manage-fraud-events"
                }
            },
            {
                url: '/user-has-limited',
                name: i18n.t('aside.user_has_limited'),
                is_navigation: false,
                rules: {
                    "security": "manage-user-limitation"
                }
            },
        ],
        is_navigation: false,
    },
    {
        url: '/marketing',
        icon: 'fa    fa-magnet',
        name: i18n.t('aside.marketing'),
        submenu: [
            {
                url: '/marketing/gateways/pardakhtyari',
                name: i18n.t('aside.pardakhtyari_ipg_gateways'),
                is_navigation: false,
            },
            {
                url: '/marketing/tools',
                name: i18n.t('aside.marketing_tools'),
                submenu: [],
                is_navigation: false,
            },
        ],
        is_navigation: false,
    },
    {
        url: '/admin-settings',
        icon: "fa fa-cog",
        name: i18n.t('aside.admin_setting'),
        submenu: [
            {
                url: "/marketing/setting",
                name: i18n.t("aside.marketing_setting"),
                submenu: [],
                is_navigation: false,
                rules: {
                    "marketing": "read"
                }
            },
            {
                url: '/customers-club-settings',
                name: i18n.t('aside.customers_club_settings'),
                submenu: [],
                is_navigation: false,
                rules: {
                    "customer-club": 'read',
                },
            },
            {
                url: '/online-contract',
                name: i18n.t('aside.online_contract_setting'),
                submenu: [],
                is_navigation: false,
                rules: {
                    "contract-manager": 'read',
                },
            },
            {
                url: '/advertising-banners',
                name: i18n.t('aside.advertising_banners'),
                submenu: [],
                is_navigation: false,
            },
        ],
        is_navigation: false,
    },
]
